import type { Engine } from "../../engine/Engine";

export type ViewportLifecycleProfileName =
  | "default"
  | "product-viewer"
  | "configurator";

export interface ViewportLifecycleProfile {
  useRenderSceneSwap: boolean;
  mergeMeshesPerMaterial: boolean;
  debugRenderScene: boolean;
}

export const VIEWPORT_LIFECYCLE_PROFILES: Readonly<
  Record<ViewportLifecycleProfileName, ViewportLifecycleProfile>
> = {
  default: {
    useRenderSceneSwap: true,
    mergeMeshesPerMaterial: false,
    debugRenderScene: false,
  },
  "product-viewer": {
    useRenderSceneSwap: false,
    mergeMeshesPerMaterial: false,
    debugRenderScene: false,
  },
  configurator: {
    useRenderSceneSwap: false,
    mergeMeshesPerMaterial: false,
    debugRenderScene: false,
  },
};

export function applyViewportLifecycleProfile(
  engine: Engine,
  name: ViewportLifecycleProfileName,
): void {
  const profile = VIEWPORT_LIFECYCLE_PROFILES[name];
  engine.setUseRenderSceneSwap(profile.useRenderSceneSwap);
  engine.setRenderSceneMergeMeshesPerMaterial(profile.mergeMeshesPerMaterial);
  engine.setDebugLogRenderScene(profile.debugRenderScene);
}

export function isViewportLifecycleProfileName(
  value: string | null,
): value is ViewportLifecycleProfileName {
  return value !== null && value in VIEWPORT_LIFECYCLE_PROFILES;
}
